import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=306d9328&scoped=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=306d9328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306d9328",
  null
  
)

export default component.exports